import { DEFAULT_IMAGE_SETTINGS } from './types.js';
import { DEFAULT_KEYMAP } from './keymap.js';
/** Merge a settings patch over a base, with a one-level merge for `progressBar`. */
export function mergeSettings(base, patch) {
    if (!patch)
        return base;
    const next = { ...base, ...patch };
    if (patch.progressBar) {
        next.progressBar = { ...base.progressBar, ...patch.progressBar };
    }
    return next;
}
/** Resolve initial settings from DEFAULT_IMAGE_SETTINGS + an optional patch. */
export function resolveSettings(patch) {
    return mergeSettings(DEFAULT_IMAGE_SETTINGS, patch);
}
/** Merge a keymap patch over a base (per-action replace, not append). */
export function mergeKeymap(base, patch) {
    if (!patch)
        return base;
    return { ...base, ...patch };
}
export function resolveKeymap(patch) {
    return mergeKeymap(DEFAULT_KEYMAP, patch);
}
//# sourceMappingURL=merge.js.map